/* Hazard stripes (M-18): ink and signal at 45°. Warnings only, always with the word. */
.hazard {
  background: repeating-linear-gradient(
    -45deg,
    var(--color-text-on-signal) 0 3px,
    var(--color-surface-signal) 3px 6px
  );
}

.hairline {
  height: var(--dimension-line-hairline);
  background: var(--color-border-hairline);
  border: 0;
  margin: 0;
}

/* Calibration stripe (M-09): magenta 12%, teal 12%, signal 76%. One per screen. */
.calibration {
  height: var(--dimension-line-stripe);
  background: linear-gradient(
    90deg,
    var(--color-calibration-magenta) 0 12%,
    var(--color-calibration-teal) 12% 24%,
    var(--color-accent-indicator) 24% 100%
  );
}
